<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div class="page">
    <div class="content">
      <div class="margin-bottom userData">
        <div style="display: flex; align-items: center">
          <img :src="clerk.avatarUrl" class="avater" style=""/>
        </div>

        <div style="margin-left: 5px">
          <div style="white-space: nowrap">{{clerk.name}}</div>
          <div>性别：{{clerk.sex == '1' ? '男' : '女'}}</div>
        </div>

      </div>

      <div style="border-top: 1px solid #999; padding: 10px 0">

        <div class="margin-bottom">审核内容</div>

        <template v-if="checkList.length!=0">
          <van-checkbox-group v-model="selectList" ref="checkAll" class="modifyBox">
            <van-checkbox v-for="(item, index) in checkList" :key="index" :name="item.id" :default="listType(item)"
                          style="padding: 5px 0" :class="item.status !== 0 ? 'noShow':''">
              <div>{{listType(item)}}</div>
              <div v-if="item.type === 0">
                {{item.content[0]}}
              </div>
              <div v-if="item.type=== 1">
                <img :src="item.content[0]" class="photo" @click.stop.prevent="handleclickImg(item.content,0)"/>
              </div>
              <div v-if="item.type === 2" class="photoBox">
                <img v-for="(listItem,index) in item.content" :key="index"
                     :src="listItem" class="photo" @click.stop.prevent="handleclickImg(item.content,index)"/>
              </div>
              <div v-if="item.type === 3 && isAudio" class="row" style="display: flex; align-items: center">
                <van-button type="primary" size="small" plain @click.stop.prevent="playAudio()">
                  {{ playAudioBtnText + formatAudioDuration(duration) }}s
                </van-button>
                <audio ref="audio" :src="audio"></audio>
              </div>
              <div v-if="item.type === 4">
                <span v-for="(item) in formatJson(item.content[0])">【{{item}}】</span>
              </div>
              <div v-if="item.type === 5">
                {{item.content[0]}}
              </div>
              <div v-if="item.type === 6">
                树洞
              </div>
              <div v-if="item.type === 7">

                <template v-for="(category) in categoryList">
                  <div v-if="formatJson(item.content[0]).includes(category.id)">
                    【{{ category.name }}】
                  </div>
                </template>
              </div>
              <div v-if="item.type === 10">
                <video :src="item.content[1]" :poster="item.content[0]" style="height: 200px;width: 100%" controls controlslist="nodownload"></video>
              </div>
            </van-checkbox>
          </van-checkbox-group>
          <van-field
              v-model="remark" :disabled="this.status !== 0" rows="1" autosize
              v-if="remark || this.status === 0"
              :label="this.status === -1 ? '未通过原因' : '备注'"
              type="textarea"
              placeholder="请输入备注"
              style="margin: 10px 0;"
              maxlength="100"
              :border="false"/>
        </template>

        <template v-else>
          <div style="margin:20px 20px;font-size: 18px;color: darkgrey">
            暂无审核内容
          </div>
        </template>


        <div v-if="status === 0" style="border-top: 1px solid #999; padding: 10px 0"></div>

        <div class="audit" v-if="status === 0">
          <div class="title" style="margin: 0 20px 0 0 ">
            <van-button type="primary" color="#6a9cf1" size="small"  @click="selectAll">全选</van-button>
          </div>
          <div class="auditBtn">
            <div class="pass" @click="auditStatus(1)">通过</div>
            <div class="noPass" @click="auditStatus(-1)">不通过</div>
          </div>
        </div>


      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import {
  Panel,
  Cell,
  CellGroup,
  Button,
  Tag,
  Icon,
  Toast,
  Dialog,
  Field,
  ImagePreview,
  CheckboxGroup,
  Checkbox
} from 'vant';
import Decimal from 'decimal.js';
import moment from 'moment';
import VueClipboards from 'vue-clipboards';
import {getClerkCheckDetail, getAuditStatus} from '@/api/clerk_check';
import { getCategoryList } from '@/api/category'


Vue.use(Panel)
    .use(Cell)
    .use(CellGroup)
    .use(Button)
    .use(Tag)
    .use(Icon)
    .use(Toast)
    .use(Dialog)
    .use(Field)
    .use(ImagePreview)
    .use(CheckboxGroup)
    .use(Checkbox)

Vue.use(VueClipboards);

export default {
  name: 'clerk-apply-detail',
  components: {},
  data() {
    return {
      isAudio: false,
      clerk: null,
      checkList: [],
      categoryList: [],
      selectList: [],
      clerkCheckId:null,
      clerkId:null,
      status:null,
      isPlayAudio: false,
      playAudioBtnText: '播放录音',
      audio:null,
      remark:null,
      duration:null
    }
  },
  computed: {

    //标题
    listType() {
      return function(item){
        let itemType = item.itemType==='gaming'?'(电竞)':''
        if (item.type === 0){
          return '名称  (提交时间:' + this.formatDate(item.createTime,'MM-DD HH:mm') + ')'
        }else if(item.type === 1){
          return '头像  (提交时间:' + this.formatDate(item.createTime,'MM-DD HH:mm') + ')'
        }else if(item.type === 2){
          return '相册'+itemType+'  (提交时间:' + this.formatDate(item.createTime,'MM-DD HH:mm') + ')'
        }else if(item.type === 3){
          return '录音'+itemType+'  (提交时间:' + this.formatDate(item.createTime,'MM-DD HH:mm') + ')'
        }else if(item.type === 4){
          return '标签'+itemType+'  (提交时间:' + this.formatDate(item.createTime,'MM-DD HH:mm') + ')'
        }else if(item.type === 5){
          return '个性签名'+itemType+'  (提交时间:' + this.formatDate(item.createTime,'MM-DD HH:mm') + ')'
        }else if(item.type === 6){
          return '服务类型:树洞  (提交时间:' + this.formatDate(item.createTime,'MM-DD HH:mm') + ')'
        }else if(item.type === 7){
          return '服务类型：电竞 (提交时间:' + this.formatDate(item.createTime,'MM-DD HH:mm') + ')'
        } else if(item.type === 10){
          return '视频 (提交时间:' + this.formatDate(item.createTime,'MM-DD HH:mm') + ')'
        }
        return '未定义'
      }
    },
  },
  methods: {
    formatJson(tag){
      return JSON.parse(tag)
    },
    formatAudioDuration(duration) {
      if (duration != null) {
        duration = Decimal.div(duration, 1000).toFixed(0)
        if (duration.length < 2) {
          duration = '0' + duration
        }
        return duration
      }
      return ''
    },

    formatDate(date, format) {
      if (!date) {
        return '';
      }
      if (!format) {
        format = 'YYYY-MM-DD'
      }
      return moment(date).format(format);
    },

    handleclickImg(photoUrls, index) {
      ImagePreview({
        images: photoUrls,
        startPosition: index,
      });
    },

    loadData() {
      Toast.loading({
        mask: true,
        message: '加载中...'
      })
      getClerkCheckDetail(
          this.clerkId,
          this.clerkCheckId,
          this.status
      ).then(res => {
        Toast.clear()
        let data = res.data;
        if (data.code == 0) {
          this.clerk = data.clerkInfo
          this.checkList = data.checkInfoList

          for (let item of data.checkInfoList) {
            if(item.type === 3){
              this.isAudio = true
              this.duration = item.duration
              this.audio = item.content[0]
              return
            }
          }

          if(this.status !== 0){
            this.remark = data.checkInfoList[0].remark
          }
        } else {
          Dialog.alert({
            title: '加载失败',
            message: data.msg
          })
        }
      })
    },

    //全选
    selectAll(){
      this.$refs.checkAll.toggleAll(true);
    },

    /** 播放录音 */
    playAudio() {
      if (this.isPlayAudio) {
        this.$refs.audio[0].pause()
        this.isPlayAudio = false
        this.playAudioBtnText = '播放录音'
      } else {
        this.$refs.audio[0].play()
        this.isPlayAudio = true
        this.playAudioBtnText = '暂停播放'
      }
      // 监听录音播放结束事件
      this.$refs.audio[0].addEventListener('ended', () => {
        this.isPlayAudio = false
        this.playAudioBtnText = '播放录音'
      })
    },

    auditStatus(val){
      if(this.selectList.length === 0){
        return Toast('请勾选内容');
      }

      Toast.loading({
        mask: true,
        message: '加载中...'
      })
      getAuditStatus(
          this.selectList,
          this.clerk.id,
          val,
          this.remark
      ).then(res => {
        Toast.clear()
        let data = res.data;
        if (data.code == 0) {
          Dialog.alert({
            title: '操作成功',
          }).then(() => {
            this.$router.back(-1)
            this.loadData();
            })
        } else {
          Dialog.alert({
            title: '加载失败',
            message: data.msg
          })
        }
      })
    },
    // 获取分类列表
    getCategoryList(){
      getCategoryList().then(res => {
        const data = res.data
        if (data.code == 0) {
          this.categoryList = data.list
        }
      })
    }
  },
  mounted() {
    this.clerkId = this.$route.query.clerkId
    this.clerkCheckId = this.$route.query.clerkCheckId
    this.status = Number(this.$route.query.status)

    this.loadData()
    if(this.$hasFeature('custom_47')){
      this.getCategoryList()
    }
  }
}
</script>

<style lang="less">



</style>
<style lang="less" scoped>
.page{
  background: #fff;

  .content{
    padding: 20px 20px 40px;

    .userData{
      display: flex;
      align-items: center;

      .avater{
        border-radius: 50%;
        width: 50px;
        height: 50px;
      }
    }

    .Time{
      margin-left: auto;
    }

    .modifyBox{
      margin: 20px 0;

      .photoBox{
        display: inline-block;
      }

      .photo{
        width: 60px;
        height: 60px;
        object-fit: cover;
        margin-right: 5px;
      }
    }

    .margin-bottom{
      margin-bottom: 15px;
    }

    .title{
      display: flex;
      margin-bottom: 8px;
    }

  }

  .selected{
    width: 15px;
    height: 15px;
    border: 1px solid #c8c9cc;
    border-radius: 50%;
    margin-right: 5px;

    &.checked{
      background: #1989fa;
      color: #fff;
      border: 1px solid #1989fa;
      display: flex;
      justify-content: center;
      align-items: center;

    }
  }

  .audit{
    display: flex;
    align-items: center;
    position: relative;
    height: 90px;

    .pass,
    .noPass{
      height: 30px;
      line-height: 30px;
      text-align: center;
      color: #fff;
      width: 94px;
      margin: 10px 10px;

    }

    .pass{
      background: #07c160;
    }

    .noPass{
      background: #ee0a24;
    }

    .auditBtn{
      display: flex;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
    }
  }

  /deep/.van-field__label,
  /deep/.van-field__control:disabled{
    color: #656565;
  }

  /deep/.van-field__label{
    margin-right: 0;
  }

  /deep/.van-field__control{
    overflow-y: hidden;
    border: 1px solid #999;
    padding: 2px 5px;
    border-radius: 10px;
  }

  .noShow{
    /deep/.van-checkbox__icon{
      display: none;
    }
  }

}

</style>
